export default {
  buildCreate(pageId, facebookUserId, hasInstagram) {
    return {
      'data': {
        'attributes': {
          'fanpage-id': pageId,
          'facebook-user-id': facebookUserId,
          'instagram-account-present': hasInstagram,
        },
        'type': 'facebook-fanpages',
      },
    };
  },
  async getExistingFanpages(axios, fanpagesStore, token) {
    let response = await axios.get('/api/facebook/facebook-fanpages/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    response.data.data.forEach(fanpage => {
      fanpagesStore.replaceOrAdd(fanpage);
    });
  },
  async createFanpage(data, axios, token) {
    return await axios.post('/api/facebook/facebook-fanpages/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async deleteFanpage(fanpageId, axios, token) {
    return await axios.delete(`/api/facebook/facebook-fanpages/${fanpageId}/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
